function m() {
  return m = Object.assign || function(n) {
    for (var o = 1; o < arguments.length; o++) {
      var r = arguments[o];
      for (var t in r)
        Object.prototype.hasOwnProperty.call(r, t) && (n[t] = r[t]);
    }
    return n;
  }, m.apply(this, arguments);
}
var s = function(o, r, t, i, p) {
  for (r = r && r.split ? r.split(".") : [r], i = 0; i < r.length; i++)
    o = o ? o[r[i]] : p;
  return o === p ? t : o;
}, z = [40, 52, 64].map(function(n) {
  return n + "em";
}), B = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
}, T = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
}, u = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
}, W = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
}, L = function(o, r) {
  if (typeof r != "number" || r >= 0)
    return s(o, r, r);
  var t = Math.abs(r), i = s(o, t, t);
  return typeof i == "string" ? "-" + i : i * -1;
}, w = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce(function(n, o) {
  var r;
  return m({}, n, (r = {}, r[o] = L, r));
}, {}), x = function(o) {
  return function(r) {
    var t = {}, i = s(r, "breakpoints", z), p = [null].concat(i.map(function(f) {
      return "@media screen and (min-width: " + f + ")";
    }));
    for (var g in o) {
      var e = typeof o[g] == "function" ? o[g](r) : o[g];
      if (e != null) {
        if (!Array.isArray(e)) {
          t[g] = e;
          continue;
        }
        for (var d = 0; d < e.slice(0, p.length).length; d++) {
          var a = p[d];
          if (!a) {
            t[g] = e[d];
            continue;
          }
          t[a] = t[a] || {}, e[d] != null && (t[a][g] = e[d]);
        }
      }
    }
    return t;
  };
}, C = function n(o) {
  return function(r) {
    r === void 0 && (r = {});
    var t = m({}, B, {}, r.theme || r), i = {}, p = typeof o == "function" ? o(t) : o, g = x(p)(t);
    for (var e in g) {
      var d = g[e], a = typeof d == "function" ? d(t) : d;
      if (e === "variant") {
        var f = n(s(t, a))(t);
        i = m({}, i, {}, f);
        continue;
      }
      if (a && typeof a == "object") {
        i[e] = n(a)(t);
        continue;
      }
      var c = s(T, e, e), v = s(W, c), R = s(t, v, s(t, c, {})), S = s(w, c, s), b = S(R, a, a);
      if (u[c])
        for (var l = u[c], h = 0; h < l.length; h++)
          i[l[h]] = b;
      else
        i[c] = b;
    }
    return i;
  };
};
export {
  C as c
};
